module.exports = __webpack_public_path__ + "img/checkedIcon.7c59663f.svg";